import React from 'react';
import BlankComponent from '../BlankComponent/BlankComponent';
import PropTypes from 'prop-types';

const skeleton = (props) => {
  
  switch(props.type) {
    case 'IFRAME':
      return (<div className="skeleton__iframe skeleton-animation"></div>);
    case 'IFRAME_ERROR':
      return (<BlankComponent>
          <div className="skeleton__iframe skeleton-animation">
            <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
          </div>
        </BlankComponent>);
    case 'CAROUSEL':
      return (<div className="carousel__iframe skeleton-animation"></div>);
    case 'CAROUSEL_ERROR':
      return (
        <div className="carousel__iframe skeleton-animation">
          <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
        </div>
      );
    case 'DESKTOP_NAVIGATION_PANEL':
      return (<BlankComponent>
        <div className="skeleton__desktop-navigation-panel skeleton-animation"></div>
      </BlankComponent>);
    case 'DESKTOP_NAVIGATION_PANEL_ERROR':
      return (<BlankComponent>
        <div className="skeleton__desktop-navigation-panel skeleton-animation">
          <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
        </div>
      </BlankComponent>);
    case 'MAIN_PANEL':
      return (<BlankComponent>
        <div className="skeleton__main-panel-title skeleton-animation"></div>
        <div className="skeleton__main-panel-description skeleton-animation"></div>
      </BlankComponent>);
    case 'MAIN_PANEL_ERROR':
      return (<div className="skeleton__main-panel-error alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>)
    case 'CONTENT_PANEL':
      return (<div className="two-three-rows__content">
        <div className="skeleton__content-panel-image skeleton-animation"></div>
        <div className="two-three-rows__text skeleton-animation">
          <div className="skeleton__content-panel-title skeleton-animation"></div>
          <div className="skeleton__content-panel-description skeleton-animation"></div>
        </div>
      </div>);
    case 'CONTENT_PANEL_ERROR':
      return (<div className="two-three-rows__content">
        <div className="skeleton__content-panel-image">
          <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
        </div>
        <div className="two-three-rows__text">
          <div className="skeleton__content-panel-title"></div>
          <div className="skeleton__content-panel-description"></div>
        </div>
      </div>);
    case 'FOOTER_PANEL':
      return (<div className="two-three-rows__content">
        <div className="skeleton__footer-panel skeleton-animation"></div>
      </div>);
    case 'FOOTER_PANEL_ERROR':
      return (<div className="two-three-rows__content">
        <div className="skeleton__footer-panel">
          <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
        </div>
      </div>);
    case "SHORT_CONTENT":
      return (
        <div className="wrapper">
          <div className="skeleton__main-panel-title skeleton-animation"></div>
          <div className="skeleton__main-panel-description skeleton-animation"></div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image skeleton-animation"></div>
            <div className="two-three-rows__text skeleton-animation">
              <div className="skeleton__content-panel-title skeleton-animation"></div>
              <div className="skeleton__content-panel-description skeleton-animation"></div>
            </div>
          </div>
        </div>
      );
    case "SHORT_CONTENT_ERROR":
      return (
        <div className="wrapper">
          <div className="skeleton__main-panel-title skeleton-animation"></div>
          <div className="skeleton__main-panel-description skeleton-animation"></div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image">
              <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
            </div>
          </div>
        </div>
      );
    case "LONG_CONTENT_PAGE":
      return (
        <div className="wrapper">
          <div className="skeleton__main-panel-title skeleton-animation"></div>
          <div className="skeleton__main-panel-description skeleton-animation"></div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image skeleton-animation"></div>
            <div className="two-three-rows__text skeleton-animation">
              <div className="skeleton__content-panel-title skeleton-animation"></div>
              <div className="skeleton__content-panel-description skeleton-animation"></div>
            </div>
          </div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image skeleton-animation"></div>
            <div className="two-three-rows__text skeleton-animation">
              <div className="skeleton__content-panel-title skeleton-animation"></div>
              <div className="skeleton__content-panel-description skeleton-animation"></div>
            </div>
          </div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image skeleton-animation"></div>
            <div className="two-three-rows__text skeleton-animation">
              <div className="skeleton__content-panel-title skeleton-animation"></div>
              <div className="skeleton__content-panel-description skeleton-animation"></div>
            </div>
          </div>
        </div>
      );
    case "LONG_CONTENT_PAGE_ERROR":
      return (
        <div className="wrapper">
          <div className="skeleton__main-panel-title skeleton-animation"></div>
          <div className="skeleton__main-panel-description skeleton-animation"></div>
          <div className="two-three-rows__content mvl">
            <div className="skeleton__content-panel-image">
              <div className="alert alert-danger">We're sorry, but the page was unable to completely load. Please refresh the page and try again</div>
            </div>
            <div className="two-three-rows__text">
              <div className="skeleton__content-panel-title"></div>
              <div className="skeleton__content-panel-description"></div>
            </div>
          </div>
          <div className="two-three-rows__content mvl">
            <div className="two-three-rows__text">
              <div className="skeleton__content-panel-title"></div>
              <div className="skeleton__content-panel-description"></div>
            </div>
          </div>
          <div className="two-three-rows__content mvl">
            <div className="two-three-rows__text">
              <div className="skeleton__content-panel-title"></div>
              <div className="skeleton__content-panel-description"></div>
            </div>
          </div>
        </div>
      );
    default:
      return (<div className="two-three-rows__content">
        <div className="skeleton__content-panel-image skeleton-animation"></div>
        <div className="skeleton__content-panel-title skeleton-animation"></div>
        <div className="skeleton__content-panel-description skeleton-animation"></div>
      </div>)
  }
};

export default skeleton;

skeleton.propTypes = {
  type: PropTypes.oneOf([
    'IFRAME',
    'IFRAME_ERROR',
    'CAROUSEL',
    'CAROUSEL_ERROR',
    'DESKTOP_NAVIGATION_PANEL',
    'DESKTOP_NAVIGATION_PANEL_ERROR',
    'MAIN_PANEL',
    'MAIN_PANEL_ERROR',
    'CONTENT_PANEL',
    'CONTENT_PANEL_ERROR',
    'FOOTER_PANEL',
    'FOOTER_PANEL_ERROR',
    'LONG_CONTENT_PAGE',
    'LONG_CONTENT_PAGE_ERROR',
    'SHORT_CONTENT',
    'SHORT_CONTENT_ERROR'
  ])
};



// WEBPACK FOOTER //
// ./src/components/Skeleton/Skeleton.js